import React, { useState, useEffect, useRef ,useContext} from 'react';
import { useNavigate, Outlet} from 'react-router-dom';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

import '../../Assets/css/scrollbar.css';
// import '../Assets/css/topCenterToast.css'

import { GlobalContext } from '../../GlobalContext';

const UnitHome = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);
    const { unitUserProfileData, setUnitUserProfileData } = useContext(GlobalContext);
    const { unitCountData, setUnitCountData } = useContext(GlobalContext);

    const token = localStorage.getItem('unittoken');
    if(!token){
        navigate('/');
    } 
    // console.log('unittotken',token);
    let decodedToken = {id:0};
    if(token) {
        decodedToken = jwtDecode(token);
    }
    const userId = { userID: decodedToken.id }

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/unitprofiles/unitget`, {userId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response => {
                setUnitUserProfileData(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });

            await axios.post(`${POCBaseUrl}/unitprofiles/unitcount`, {userId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response => {
                setUnitCountData(response.data.data);
                // console.log('countData',response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
        }

        fetch();

        // setInterval(fetch, 3000);
    }, []);

    // console.log('globalvariable',globalVariable);
    const scrollRef = useRef(null);

    const [logoutDropdownOpen, setLogoutDropdownOpen] = useState(false);

    const toggleLogoutDropdown = () => {
        setLogoutDropdownOpen(!logoutDropdownOpen);
    };

    const [openSidebarDropdown, setOpenSidebarDropdown] = useState(null);

    const toggleSidebarDropdown = (dropdownName) => {
        setOpenSidebarDropdown(openSidebarDropdown === dropdownName ? null : dropdownName);
    };
    const [dynamicButtons, setDynamicButtons] = useState(['User Profile']);

    const deleteButton = (title) => {
        const index = dynamicButtons.indexOf(title);
        if (index !== -1) {
            const updatedButtons = [...dynamicButtons];
            updatedButtons.splice(index, 1);
            setDynamicButtons(updatedButtons);
            const currentButtonsLength = updatedButtons.length;
            // console.log(updatedButtons[currentButtonsLength-1]);
            setCurrentTab(updatedButtons[currentButtonsLength-1]);
        } 
    };

    const createButton = (title) => {
        const index = dynamicButtons.indexOf(title);
        if (index !== -1) {
        } else {
            const updatedButtons = [...dynamicButtons]; 
            updatedButtons.push(title);
            setDynamicButtons(updatedButtons);
        }
        setCurrentTab(title);
    }

    //-------------------scroll part-----------------
    const handleKeyDown = (event) => {
        if (scrollRef.current) {
            switch (event.key) {
                case 'ArrowUp':
                    scrollRef.current.scrollBy(0, -5); // Scroll up
                    break;
                case 'ArrowDown':
                    scrollRef.current.scrollBy(0, 5); // Scroll down
                    break;
                default:
                    break;
            }
        }
    };

    useEffect(() => {
        // Add event listener for keydown
        window.addEventListener('keydown', handleKeyDown);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    //----------------tab event-----------
    // const [currentTab, setCurrentTab] = useState('User Profile'); 
    const selectTab = (title) => {
        // setCurrentTab(title);
        setCurrentTab(title);
        switch (title) {
            case 'User Profile':
                navigate('/unituserprofile');
                break;
            case 'Group list':
                navigate('/unitgrouplist');
                break;
            case 'Create groups':
                navigate('/unitcreategroup');
                break;
            case 'User list':
                navigate('/unituserlist');
                break;
            case 'My bounding':
                navigate('/unitboundinglist');
                break;
            case 'Create bounding':
                navigate('/unitcretebounding');
                break;
            case 'Records':
                navigate('/unitrecords');
                break;
            case 'SOS record':
                navigate('/unitsosrecord');
                break;
            case 'Current overrun record':
                navigate('/unitcurrentoverrunrecord');
                break;
            case 'History transgresses':
                navigate('/unithistorytransgresses');
                break;
            default:
                navigate('/unituserprofile');
                break;
        }
    }
    //-----------button list scroll bar-------------
    const [height, setHeight] = useState(47);

    useEffect(() => {
        if(dynamicButtons.length > 7) {
            setHeight(58);
        } else {
            setHeight(47);
        }
    }, [dynamicButtons]);
    //-------refresh----------
    const [refreshKey, setRefreshKey] = useState(0); // Unique key for the component
    const handleRefresh = () => {
        // window.location.reload();
        setRefreshKey(prevKey => prevKey + 1); // Increment the key to trigger remount

        toast.success('Refresh successfully', {
          className: 'centered-toast-success',
          bodyClassName: 'centered-body',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          pauseOnHover: false,
          draggable: true,
        });
      };

      useEffect(() => {
        console.log("Div refreshed!"); // Optional: Do something when the div refreshes
      }, [refreshKey]);

      const imageSrc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAAFfklEQVRYha2Y72tbZRTHv+dZXrT7dSNNEQaj3V7oC2HtXrgXiuQiithtJnVjq63abEz3svkPmvwH2cs6xho3y5wbTaxTUGEpA5HJoBPEd1sDQ5C0W9O5xRc3z5Fz8yS9yb3pkuBDKTc3957zud9z7nnOCTEzelnP8+MpQM2CFIgIgAJIpfuPLaR6sdc1yLPFY2FA2SCVJKLoztiiUKCydIoBtQxSGRAV+o9+tdGN3VCnF/5z870EoBIgFSXSAMufanwvD0Sko2BERZ3KrallgprvO3plvhP7L1Tk6Tdvy9PPE9QQtkLQCMeu8W9dRZ7nT3BLmCDXE1QRpBJ9Y9lCzyCb16MZgppxAcSJ64CWAZUDqVEimm4By4LUChHFARX1wMg1F/rGssmuQDavvREGqABSIx6AvOTFnpM/r8IN1fuilE3NKhV2xhbdJ68snRoGJF9UzANzH4DdN5b15Y8PpLxwJAxSBRIIuEqURdq9p5Zz20nbblWWJuISWhBZ28Eo//2cAesRZi3HZbC2e4WQ1X/8Wk5sgLnMkCTXIwAyrdc1KbJx9bDQL5LEFiRK2NZHv670CuFdlaWJUVHao8x431i28YANkI0rhyQkqwBZtXircWvyt56VaAPjPqjJGXnQ4XqIGnWEWScJcCHAOmtN3WsL8fTGuzZRKEFqRxwUskiFQBQqQ4UKRDsy7V5VCVNlaSILqGkmbRFD3iK3EntyhBNuXtRyo22Z3vz6rQy0c5vZmWZdtcAOWDtgdixoJ8Zcvf3v99O+HNhaOuX6YAZDJ+qnXZDH2VdHwXpIaiWzzoc/XlkNMlFeOJJh7cwwO0DNOVhX4YEx56sz7WD6j19fBXTewAxVbk2NbinCHDcZLR8CS/KTK4dsgQBXW5xuC2MH2WIWH8Yfc9wFWb98UKSKG6nkS/vJl6/5DbCTZOOsCxhfJX2eH7fFR+0lcf3FK99NpkJgnmXSIK4JxKRniCGZ3JRwrB3bzWPU7q/ltCmqYk8Fno8FqGET6Zn6pkmkR8AYCcldA2eLVL/w8fwrLGB+A5KMxlEXMH5D2gXYFb/Z8CktRMi9s+XCQAu62uyoUxi/IXNzk0oIyb/1S/u5aesO2JCZnTJpWN3CBIRGwoFnix80tQ0KrNPMXPRkcZqh/QVJO7laElaxlbQOXpDA+YDQFJg5XfdnfKdV5LO/5K3JebK4MHDmgQ+EuZpBw1HHML5asvvEDwUDU/eX2xlbTBnxdMHQyXE8KLKD59dWmKvpLmAu7Dn5U5uuTMpFw597jTJxK3ikSqxf2h9uA5PqECa99/SdwG7s6Y13wmBOePxtgQx+/vcGM2fNlxYzt23pDMwBaCfL7BQ9MG Wwe+6wNXm3/UjBOsnQFmpqZHd/eMvdfRttQGlucBikHposli16NHLuUeCe0+vavB4dJqgV6UlMC3pg98kfV+EtGIPnS6uy/Zu4WZJE/yvEtTfD7ktRV4N1tg4Bf+XiJFgXDczI2sV9Hc0kna1aC1qrrLqIlvD7mufSXGTUdPCWCdN9aRkj5x51NbnVV3nh9cZE4G1B956+09SCBo4TpblIHKB5D4zcnIyce9RQaP3yQZtqo6d3dim89OkfjVd24+phmQwzRMqqTwQkEBO/+PrgtgNWgDJiqEhEGTNgJUA0S81TXdodHUBxIpUEqSEDID1wGSDbmrwb2IxvO+mV5iJho0yMAsZNOR44+9DdRWXX9igjpuGGonYsw1kiPHWvbXi3HcIHz6/JjfHS3KDNUCkzZNf7iOZd1Ox6jd6GlLSdywSkwp/8vu3c+0KQLaCSGLJLX7w8TCTlGXGGzL7aanDABSgDaoVJ54iRe2n6z47rUM8/1Kxd3JcCqdmW6T89cOZB9z/UAPgPPFS/i4lU1PcAAAAASUVORK5CYII=";
      const imageSrc1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAAE6UlEQVRYw82Y3WobVxDH/zNHthLTIPWizSdkExJIoCWbixZaiCURmkAL9RLyAOu8QOw32D5B1ReIZfIAlQv5LMGSA/1ILrxue9cib0wC7ZUlVo0jx2dOLnQkr2Q5yLUdKliQVqPd3/x15j9nlowx+D+8UjsJbl294oDZM8wemF0ozoAZhhloHw2wCsFUNkqVx2ZvR8Nem4ZRpFXI5cEcgDkHVui5uWL0waAdQzBKVcEcjM3MVnYFsv75Z1kwl8A8YVT/jYaGAZirIPLHbpWiHYO8/vSTvGEug9vygxm7hGmAyBu7VRqoDg+EuOj6EJknkQxE0DlIb76H6Pa5zmf7HUl/jAFpDYhkYMz8yxu+P5Qirz/+yAXzYjtLNSDLXSsDEBX6lekB2Th/LgvmyCT+jn2CaYDITa6Z3vIVKQHIEID+ldN/7r/FKBA0DJABcwlAfosi+vTpvFE835N1MqP9UabQKe1UQo1gb7LekTJBRxUyxkCfOO6A1fLgLPddmVNjs7ejlFXDG5BRFUAdQJYA1wCZATENACGAOgGOAS5so0wDQEhAZAAX3TgFgvYAFFMAQCL5hHRzAPxUrVZPVhMBZQPkEveZHn3ytNjjxOOX8gYoATiZgJlO37nbE7d2/ZoLoAIgA6hNEIi4nQzV8xceAGjHccFcNIqnUn/+FW6cP+cTsGyBp0cWw+J6btyVQ+8VzaFDWXPwYHFs4XFpffySZ4BFe8/v0g8eFgHg1VdfToHZgeLgYPmHcO36tRKAm2grZJ1Vy0nrimFi8XoQyZGWxY2zZwxElm3Ms5Gl34oAQHEccNzMURxfoLW1mZc3/OzowuOQtMxad+2qSiI+RG5Cy+or72tDIjdtTGYTZNOic3LksAsAamUlgMj7EJkkLdWE1Xdhqdl0KI7BcRMUx6C1Ndder2LbQdcn0vfuuyRyESLfQEujpx10QPr6RUWOHPb1saNZtbJSV1FUUrVanrRM9oNwHDvUbEN0YCxIZHtTrlXIVVqXC56FCQ/cuRtAxIFNjpIgfc0rA5EZElnVx45G+sRxHwBUrVYiLXPJLCmOQ45jJGDqnTWXaJQ5iHzfulwwrS8ul1tXr7gH7tytQ8TrNMokyDMLswSRArQUILJEIich4ifWTZ205DbOnskCAP37stIGiEHN5tJodSG0CnsWZBoiBdIyDZEGRCYg2gEACwNoaWw6q+jQlpxDQESrqxEAVz78wFd//1MCAH3iuAtWni3JEgAPxgREVLEZhd0thFI5W4X50Z9+LgKorI9fKhvAST+ar9htZ0DMMPZ3ZIyBGR2dguJvrSM2wBwY5hDMdSjO2n2q394kqY47PjOKAzBH9nBtzESfA1fBXLQxMIodME8ltp3T6Xv3i+2ml0o5hnm5bcVqq7VvsWiFPWwHp9IPHlqL39iIKJWq9jkn3kETrKZ/fBQN6r7z+9Ntt40Jtm6MRCpgniNg4h3BVNMLjyuDd2jG+BCJCMjsM0wDgL/9pGdMHUR5iCzu36YIIMAb+eXX6O3jhDEhjJnsuq3eHB3ePj7obcaOvhFD68mRJ08rw096RC6IKmDOmG4J76q0G4bZG/n9j+EHrIQyDkTm9kCZKkTc7SCGHsLBnLdum9uhMlUwB6pW290QvvUhRsoxzB4Ue2DldubiBEwDzKGdmcvq+Yu9fSzxLl5vAHznTA/brldpAAAAAElFTkSuQmCC";
      const imageSrc2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAAEIklEQVRYhb2YS28TVxTHz7n3aqquYhnn0SiOpyxYRKJ2Fl10gexUXYCE6JjwDG1sVaIBkYX5BDifgCBFoCDUjAOlcaF0VCG1SFU7VhcsurFbKaq6qcfmkcSAnG7AFjNT3fE4OI0n9TiTHsmaueO5c39zHv9zbTRNE7S54SQgWUCkAEhg65EAIN18JAQQaOOIpABIk/0TD/LPvzktIxVUv5SRwYUR+9ZZN5PaWBgAVH7Z0F8mTL2+8EJJJLsB6dkhyMYzjNcvOQy4hSEd3OPKzNevuoLxHIRDdAPjPYj+qiuY3fDIejcwnoKsfXXIZ+q12cbibWFiTnOZlyC8hN8OvJfsO3U/7XZiU9DM9kLWsaBt/X7rczREmvLHbyrtQDzPkW0sBACOavt/gsB2wumUI+sAkAIAZehsoep2tUr2SMxuG+FO5zh5RAlOLctDn//uGoJb78nvVPtFOjYnEKk8PyJ1AwENj4gA4KpynELDY/nto+v7u68al7ZbycpzLAMAcQB4d8/4EgLAKACMOU3wWtC4XeFh6T2hWPn1RP7AfJo5AEhobuBT1VFZvfQI90K879T9VO3vYuTxjVHlyRfvm/yLdxK/cI9EV299VF29fVBeWzos7iaI1Hf6e6U8P8LL9mcAiNneKTzNHOBAmi1ovAj+qmSlTcnsVWhm+iceqOVr+2QgLNEMz+Bnv24p/9XbB9M20KVnd46JgeN3rY7s1GvWAUksOLWc75SkdHVvCpFdBsIuBqeWN/bAla+P+ggVIkiFvF9a3ACrZCUZOTSh8cB4VnECyQTP/dHxflObG/YhYUVElg+e/9NKyJXFqA/pWwpSIYpEAEIFQCpkADDllzIW0LM7x4pAKATGs6JTaCxBQ6TV/9CR6sCkmrfj3tP6a8Aw6ippkXijkZAJpIJo5w/Yorfw/N6ZyLaC1oEzctrccKpFRa3+9Oj6/hhSIWz8qxrscfSFMhnxS4v5ljYge5GsPrvFj9nVAqbxZifmAOOzh+HmPC8FjUPkrMX0Wr7N4pvGtuWa8DvVEV9ousQ77UV7bCV46EJRMfSaZhp1vk+1PoZ1XuPnhd4T91T7/mZOxXcKEl659SF3c3P796bSTENqA6OZeq21GpO2IqteKKsUmi4VbTdfKs+PRPjF0HQpH7pQFA29NmYa9RlTr48NJh+KA5M5S5sqWYlX2sc8Ufcc/bLa1BFepj1dbp61gU9+EktX94pcR4AwQMJiQ2d/cxTDtaXDEiLjgsZ1JBYYz1a9+ltipv/Mj+nytX0RIExFwvhLZZCwNBAmI7Io776ILAWEpbiiIrICEpYMHL9rAVsgXlp5foSr7CwiTSBhwD00mHyIKzdjJmJjjIRdQWTp3pONrcKugDTt8Y1REQmTgLDLHAAJ1fjiQJjSP/HD5mYIAP8AShjeV8cJe3YAAAAASUVORK5CYII=";

    return (
        <>
            {/* -------Header------- */}
            <div className="bg-[#2776c3] w-full pl-6 pr-4 m-0">
                <div className='flex justify-between p-0 m-0'>
                    <div className='w-[215px] h-[65px] text-[white] text-[25px] whitespace-nowrap flex flex-col justify-center' style={{ color: 'white', fontFamily: 'Liberation Serif' }}>
                        {/* <img className="w-[215px] h-[49px] mt-2 ml-[-14px]"
                            src="https://proxy.poc-global.com/api/img/pc/logo.png" alt="Logo" /> */}
                        Irish Cellular Communications Ltd
                    </div>
                    <div className="flex flex-row justify-center items-center m-0 p-0">
                        <div className="relative bg-[white] h-full">
                            <button
                                onClick={toggleLogoutDropdown}
                                className="h-full text-white px-3 py-2 rounded flex items-center"
                            >
                                <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsSAAALEgHS3X78AAADHklEQVRIib2Wz2oUQRDG6/uqN9fN2RUUEf+AMBGCBy9OFPEiGNC7+wgLGkQQ3Ijo0eDRSNicxFv2CYwoBhFhVxRBCJo32DxBpHt6Zno6O+smqBOa/pfUr77qrq5gb29PpvmOXl1L0TBtNMwiG9pEw4hvu5wxG2iY3o/nVzansfVHaGthdVaAHmfMjQAkLMaa9TNurQ/V9venF0eHhjqgyCaMJt6oIGr0QDc2KqAOSaZfH1+oBfMPkdgEmUCtMYpo1hA0N6efA0IgATkxzLXQ1sJqV0SSApSpKEExGBDAOwAkc8uD7mGUdiqGrTFjx+qaqFbAGRBerQN3DgRtLawuCtCMDQtjhZkDJdDDrWqyOf/k2+JBlM7tM6wTQlsAkQPt2dq1uemh1khsWMPQhmENgcWZFuOpobWKArj4G80ynBEwU30A6PjLIvG5hsA8tMH5WocOonQQnqkEZ2pvcJkilfOLLpTbH4y1X/ciHbv1esSGadY9fVQV0ja63sGra7tbSydnp1bq1a7UnmscTpubZHShsFJre9Lbe+J2f4CGSRir9epc03JcrCuHW3dPjk2XiUoztZpCdVi5UPXnl6klhgDTSXYnQrfXro+gTKHs5ylS3tg4Px24b4Ef7pw4fGkLvzP33qektqlcJLUZhHiXyg1Sex/vnf47RfxffGaczaPXem0YdqCauJKmHMLoys9XN3u1kVh614ayAzDxt/styc6XR/P7crWitHX55XEY9qB6ycNEjH8YsvkOjHa2165v5H9zqvOmDaNdKI8VzyIrabQ86J7vjoW2FlatpyswmpW0vHYWUP/mGjfegeovGD3uYEaDt5ceBgmcWAfY+fzg3KiAuv8SgIe5Otd7mITwMY7k6cQAWsIQOMEhyPTT/bMjHElf2Ar/LARKGc6q0mIvgrOiqgQTkRMcAkhtnnZt5bA1NOu9h95Qth7veeOs5qsUT2Ne1oJx1ic2zBbaLA1lRnKAVADct+f6GFSZV/f9uE3ERkIFvn6KlmrDKDhjMkZhNHc/5e/OUhTrcciqSuujUFEhpRMxOHKi9/9fJBH5DWAKi/sKMz3wAAAAAElFTkSuQmCC"
                                    alt=""
                                    className="w-[26px] mr-[5px] border-0"
                                />
                                <span className='m-0 p-0 cursor-pointer text-[#2776c3] text-[14px]' style={{ fontFamily: 'Liberation Serif' }}>Hello {unitUserProfileData.account || ''}</span>
                                {!logoutDropdownOpen ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </button>
                            {logoutDropdownOpen && (
                                <div className="absolute right-0 w-full bg-[gray] shadow-lg rounded flex cursor-pointer">
                                    <div className='flex flex-col justify-center'>
                                        <svg
                                            className="h-6 w-6 flex flex-col justify-center text-[white] focus:outline-none focus:border-0 ml-3"
                                            focusable="false"
                                            
                                            viewBox="0 0 24 24"
                                            data-testid="LogoutIcon"
                                            tabIndex="-1"
                                            title="Logout"
                                            fill='white'
                                        >
                                            <path d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4z"></path>
                                        </svg>
                                    </div>
                                    <div className="block px-2 py-2 text-[white]" style={{ fontFamily: 'Liberation Serif' }} onClick={()=> {navigate('/');localStorage.removeItem('unittoken')}}>Logout</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* --------------Body container-------------- */}
            <div className='w-full h-full bg-[#ffffff]'>
                <div className="w-full h-full flex">
                    {/* --------------sidebar-------------- */}
                    <div className="h-screen !w-[240px] bg-[#f0f0f0] text-[#5a5655] border-r border-[#ddd]">
                        <div onClick={() => {createButton('User Profile');navigate('/unituserprofile')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff] cusor-pointer">
                            <img
                                src="https://proxy.poc-global.com/api/img/pc/self_icon.png"
                                alt=""
                                className="imgcl"
                            />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>User Profile</span>
                        </div>
                        <div onClick={() => toggleSidebarDropdown('group')} className="!w-[240px] flex justify-between items-center  border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src="https://proxy.poc-global.com/api/img/pc/grop_icon.png"
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My group</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{unitCountData.groupCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'group' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'group' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Group list');navigate('/unitgrouplist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Group list</div>
                                <div onClick={() => {createButton('Create groups');navigate('/unitcreategroup')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create groups</div>
                            </div>
                        )}
                        <div onClick={() => toggleSidebarDropdown('user')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img
                                    src="https://proxy.poc-global.com/api/img/pc/user_icon.png"
                                    alt=""
                                    className="imgcl"
                                />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My user</span>
                                <span className='text-[#2776c3] text-[14px] pl-[10px] pr-[10px]'>{unitCountData.userCount || 0}</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'user' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'user' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('User list');navigate('/unituserlist')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">User list</div>
                            </div>
                        )}
                        <div onClick={() => toggleSidebarDropdown('bounding')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img src={imageSrc} alt="Base64 Image" className="imgcl" />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My Bounding</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'bounding' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'bounding' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Bounding list');navigate('/unitboundinglist');}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Bounding list</div>
                                <div onClick={() => {createButton('Create bounding');navigate('/unitcretebounding')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Create bounding</div>
                            </div>
                        )}
                        <div onClick={() => {createButton('Records');navigate('/unitrecords')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff]">
                            <img
                                src="https://proxy.poc-global.com/api/img/pc/audio_icon.png"
                                alt=""
                                className="imgcl"
                            />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>Records</span>
                        </div>
                        <div onClick={() => {createButton('SOS record');navigate('/unitsosrecord')}} className="flex items-center border-b border-[#ddd] h-[47px] w-full pl-5 hover:bg-[#ffffff]">
                            <img src={imageSrc1} alt="Base64 Image" className="imgcl" />
                            <span className='pl-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>SOS record</span>
                        </div>
                        <div onClick={() => toggleSidebarDropdown('crossborder')} className="flex justify-between items-center border-b border-[#ddd] h-[47px] w-full pl-5 pr-5 hover:bg-[#ffffff]">
                            <div className='flex items-center'>
                                <img src={imageSrc2} alt="Base64 Image" className="imgcl" />
                                <span className='pl-[10px] pr-[10px] text-[14px] cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>My Bounding</span>
                            </div>
                            <div>
                                {openSidebarDropdown !== 'crossborder' ?
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0" // You can adjust the size and color as needed
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropDownIcon"
                                        tabIndex="-1"
                                        title="ArrowDropDown"
                                    >
                                        <path d="m7 10 5 5 5-5z" />
                                    </svg>
                                    :
                                    <svg
                                        className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                        focusable="false"
                                        
                                        viewBox="0 0 24 24"
                                        data-testid="ArrowDropUpIcon"
                                        tabIndex="-1"
                                        title="ArrowDropUp"

                                    >
                                        <path d="m7 14 5-5 5 5z"></path>
                                    </svg>
                                }
                            </div>
                        </div>
                        {openSidebarDropdown === 'crossborder' && (
                            <div className="pl-4 bg-[#fbfbfb] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                                <div onClick={() => {createButton('Current overrun record');navigate('/unitcurrentoverrunrecord');}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">Current overrun record</div>
                                <div onClick={() => {createButton('History transgresses');navigate('/unithistorytransgresses')}} className="block py-2 hover:bg-[#ffffff] pl-10 cursor-pointer">History transgresses</div>
                            </div>
                        )}
                    </div>
                    {/* --------------content-------------- */}
                    <div className="w-[calc(100%-240px)] h-screen flex-1">
                        {/* ---------button list----------- */}
                        <div className="tab-list-scroll w-full flex justify-between items-center border-b border-[#ddd] hover:bg-[#ffffff]" style={{ height: `${height}px`, transition: 'height 0.3s' }}>
                            <div className="w-[calc(100%-42px)] box-border flex whitespace-nowrap overflow-x-auto" style={{ overflowX: 'auto'}}>
                                {dynamicButtons.map((data, index) => (
                                    <div
                                        onClick={() => selectTab(data)}
                                        key={index} // Use a unique key for each element
                                        className={`flex ${data === currentTab ? 'bg-[#dddddd] text-[#2776c3]' : 'bg-[#eeeeee] text-[#5a5655]'} box-content px-5 border-l border-[white] border-b border-[#ddd] !h-[45px] leading-[45px] whitespace-nowrap cursor-pointer text-[14px]`}
                                    >
                                        <span style={{ fontFamily: 'Liberation Serif' }}>{data}</span>
                                        <div className='flex flex-col justify-center'>
                                            <div onClick={() => deleteButton(data)} className='ml-[10px] hover:bg-[#2776c3] h-6 w-6' >
                                                <svg
                                                    className="h-6 w-6 text-gray-500 focus:outline-none focus:border-0"
                                                    focusable="false"
                                                    
                                                    viewBox="0 0 24 24"
                                                    data-testid="CloseIcon"
                                                    tabIndex="-1"
                                                    title="Close"
                                                    fill='white'
                                                >
                                                    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div onClick={handleRefresh} className=" W-[32px] flex flex-row justify-center items-center text-[32px] refreshable-div" key={refreshKey}>
                                <svg
                                    className="h-[32px] w-[32px] focus:outline-none focus:border-0 font-normal leading-none mr-[10px] cursor-pointer"
                                    focusable="false"
                                    
                                    viewBox="0 0 24 24"
                                    data-testid="LoopIcon"
                                    tabIndex="-1"
                                    title="Loop"
                                    fill='#5a5655'
                                >
                                    <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z" />
                                </svg>
                            </div>
                        </div>
                        {/* --------------tab--------------------- */}
                        {(currentTab === 'User Profile'  || currentTab === 'Create groups' ||  currentTab === 'Edit group' || currentTab === 'Add users' || currentTab === 'Edit users' ) &&
                            (<div className='h-full'>
                                <div className="h-[calc(100%-116px)] p-2.5 pb-1.5 overflow-auto" ref={scrollRef} style={{scrollbarWidth: 'none'}}>
                                    <div className="h-[42px] border-b border-gray-300">
                                        <span className="inline-block h-[42px] leading-[41px] px-5 text-[15px] text-gray-600 border border-gray-300 border-b-[white] rounded-tl-[5px] rounded-tr-[5px] bg-white" style={{ fontFamily: 'Liberation Serif' }}>
                                            {currentTab}
                                        </span>
                                    </div>
                                    {/* ----------------tab content--------------- */}
                                    <Outlet/>
                                </div>
                            </div>
                        )}
                        {(currentTab === 'Group list' || currentTab === 'User list' || currentTab === 'Bounding list' || currentTab === 'Function card record' || currentTab === 'System annoucement' || currentTab === 'User management' 
                        || currentTab === 'Records' || currentTab === 'SOS record' || currentTab === 'Current overrun record' || currentTab === 'History transgresses' || currentTab === 'Create bounding') &&
                            (<div className='h-full'>
                                <div className="h-[calc(100%-116px)] p-2.5 pb-1.5">
                                    <div className="h-[42px] border-b border-gray-300">
                                        <span className="inline-block h-[42px] leading-[41px] px-5 text-[15px] text-gray-600 border border-gray-300 border-b-[white] rounded-tl-[5px] rounded-tr-[5px] bg-white" style={{ fontFamily: 'Liberation Serif' }}>
                                            {currentTab}
                                        </span>
                                    </div>
                                    {/* ----------------tab content--------------- */}
                                    <Outlet/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default UnitHome;